import styled from '@emotion/styled'
import type { FC } from 'react'

import Button from '@segment/matcha/components/Button'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import type { SingleCard as SingleCardProps } from '../../data'

const SingleCard: FC<Omit<SingleCardProps, `type`>> = ({ title, description, href, cta }) => {
  const pageConfig = usePageConfig()

  return (
    <StyledCardBase href={getAbsoluteUrl(href, pageConfig)}>
      <Card.Body>
        <Card.Copy>
          <Card.Headline>{title}</Card.Headline>
          <Card.Description>{description}</Card.Description>
        </Card.Copy>
        <Card.Action>
          <Button color="primary" size="medium" variant="filled">
            {cta.title}
          </Button>
        </Card.Action>
      </Card.Body>
    </StyledCardBase>
  )
}

const StyledCardBase = styled(CardBase)`
  margin: 80px 0 0;
  width: 100%;
`

export default SingleCard
